// extracted by mini-css-extract-plugin
export default {"settings-group":"YOvBiubR","settingsGroup":"YOvBiubR","title":"Y5b2EaDe","toggle":"KUgL7uYH","content":"oETMbvr7","compact":"HLDjP1Zk","subtitle":"IQrOPl9n"};